import React from 'react';
import { Box, SimpleGrid, Heading, Text, VStack, SkeletonText, Badge, Link, Flex, Divider, Spacer } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { formatDistanceToNowStrict } from 'date-fns';
import { ptBR } from 'date-fns/locale';

const formatDistance = (dateString) => {
    if (!dateString) return '-';
    return formatDistanceToNowStrict(new Date(dateString), { addSuffix: true, locale: ptBR });
};

const statusColors = { aberto: 'blue', em_andamento: 'orange', bloqueado: 'purple', fechado: 'gray' };
const priorityColors = { baixa: 'green', media: 'yellow', alta: 'orange', urgente: 'red' };

const TicketListCard = ({ title, tickets, loading, emptyText }) => {
    return (
        <Box
            p={4}
            bg="white"
            borderRadius="md"
            boxShadow="sm"
            borderWidth="1px"
            minH="220px"
        >
            <Flex align="center" mb={4}>
                <Heading size="sm" color="gray.600" whiteSpace="nowrap">{title}</Heading>
                <Spacer />
            </Flex>
            <Divider mb={4} />
            <VStack spacing={3} align="stretch">
                {loading ? (
                    Array.from({ length: 5 }).map((_, index) => (
                        <SkeletonText key={index} noOfLines={2} spacing="3" skeletonHeight="3" />
                    ))
                ) : tickets && tickets.length > 0 ? (
                    tickets.map(ticket => (
                        <Link as={RouterLink} to={`/tickets/${ticket.id}`} key={ticket.id} _hover={{ textDecoration: 'none' }}>
                            <Box p={2} borderRadius="md" _hover={{ bg: 'gray.100' }}>
                                <VStack align="start" spacing={1}>
                                    <Text fontSize="sm" fontWeight="medium" noOfLines={1} w="full">
                                        #{ticket.id} - {ticket.subject}
                                    </Text>
                                    <Flex align="center" w="full">
                                        <Badge
                                            colorScheme={statusColors[ticket.status]}
                                            textTransform="capitalize"
                                            fontSize="10px"
                                        >
                                            {ticket.status?.replace('_', ' ')}
                                        </Badge>
                                        <Badge
                                            colorScheme={priorityColors[ticket.priority]}
                                            textTransform="capitalize"
                                            fontSize="10px"
                                            ml={2}
                                        >
                                            {ticket.priority}
                                        </Badge>
                                        <Text fontSize="xs" color="gray.500" ml={2}>
                                            · Criado {formatDistance(ticket.created_at)}
                                        </Text>
                                    </Flex>
                                </VStack>
                            </Box>
                        </Link>
                    ))
                ) : (
                    <Text fontSize="sm" color="gray.500">{emptyText}</Text>
                )}
            </VStack>
        </Box>
    );
};

const TicketSummaryDashboard = ({ stats, loading }) => {
    return (
        <Box mb={6}>
            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={5}>
                <TicketListCard
                    title="Meus Tickets"
                    tickets={stats?.criadosPorMim}
                    loading={loading}
                    emptyText="Você não tem tickets abertos."
                />
                <TicketListCard
                    title="Tickets Atribuídos a Mim"
                    tickets={stats?.atribuidosAMim}
                    loading={loading}
                    emptyText="Nenhum ticket ativo atribuído a você."
                />
                <TicketListCard
                    title="Tickets Reclamações ML"
                    tickets={stats?.reclamacoesML}
                    loading={loading}
                    emptyText="Nenhuma reclamação ativa atribuída a você."
                />
            </SimpleGrid>
        </Box>
    );
};

export default TicketSummaryDashboard;

